import { configureStore } from "@reduxjs/toolkit";
import websiteReducer from "../compontants/slice/websiteSlice";
import websiteprojectReducer from "../compontants/slice/websiteProjectSlice";
import userReducer from '../compontants/slice/userSlice';
import allpropertyReducer from '../compontants/slice/userSlice';
import myPropertyReducer from '../compontants/slice/MyPropertiesSlice';
const store = configureStore({
  reducer: {
    website: websiteReducer,
    projects: websiteprojectReducer,
    user: userReducer,
    allproperty:allpropertyReducer,
    myproperty:myPropertyReducer,
  },
});

export default store;
